export default {
  messageBlocked: "Nachricht wurde vom System blockiert",
  outboundCustomerLabel: "An den Kunden gesendet",
  customerActionCancel: "Stornieren",
  customerActionReceipt: "Quittung",
  messageSent: "Nachricht gesendet!",
  agreementReached: "✅ Buchung bestätigt!",
  sendMessageError: "Nachricht konnte nicht gesendet werden",
  cancelConfirm: "Möchten Sie diese Unterhaltung wirklich stornieren?",
  conversationCancelled: "Unterhaltung storniert",
  cancelConversationError: "Unterhaltung konnte nicht storniert werden",
  cancelReasonAdmin: "Vom Staff storniert",
  cancelReasonPartner: "Vom Verkäufer storniert",
  reopenSession: "Handshake wiedereröffnen",
  reopenSessionBusy: "Wird wiedereröffnet…",
  reopenSessionSuccess: "Handshake wiedereröffnet",
  reopenSessionError: "Handshake konnte nicht wiedereröffnet werden",
  reopenSessionConfirmTitle: "Handshake wiedereröffnen?",
  reopenSessionConfirmMessage:
    "Die Buchung kehrt in die Verhandlung zurück, damit Datum und Uhrzeit im Chat mit dem Kunden geändert werden können.",
  reopenSessionConfirm: "Handshake wiedereröffnen",
  loadingAudit: "Audit-Daten werden geladen...",
  replyPlaceholder: "Dem Kunden antworten...",
  adminReplyPlaceholder: "Als Partner dem Kunden antworten...",
  conversationNotFound: "Unterhaltung nicht gefunden",
  bookingDetails: {
    title: "Buchungsdetails",
    service: "Gebuchter Service",
    activity: "Aktivität",
    partyHeading: "Gruppengröße",
    visitHeading: "Gewünschtes Datum & Uhrzeit",
    visitFull: "({{datetime}})",
    visitNotSet: "Noch kein Datum/Uhrzeit — im Chat vereinbaren",
    visitOpenShort: "Datum im Chat vereinbaren",
    visitScheduledMissingShort: "Kein Datum in der Buchung",
    quantityUnknown: "Nicht angegeben",
    notes: "Kundennotizen",
    partyGuests_one: "{{count}} Gast",
    partyGuests_other: "{{count}} Gäste",
    partyQuantity_one: "{{count}} Einheit",
    partyQuantity_other: "{{count}} Einheiten",
  },
  started: "Gestartet {{date}}",
  conversationEmpty:
    "Noch keine Nachrichten. Antworten Sie, um die Unterhaltung zu starten.",
  agreementReadOnly:
    "Dieser Handshake ist abgeschlossen. Die Buchung wurde auf Flitrip bestätigt.",
  confirmBooking: "Buchung bestätigen",
  confirmBookingHint:
    "Nutzen Sie dies, sobald Sie und der Kunde die Details im Chat geklärt haben. Legen Sie Datum und Uhrzeit der Erfahrung fest und bestätigen Sie dann auf Flitrip.",
  confirmVisitDateLabel: "Datum der Erfahrung",
  confirmVisitTimeLabel: "Uhrzeit",
  confirmVisitRequired: "Geben Sie Datum und Uhrzeit der Erfahrung ein.",
  confirmVisitMustBeFuture:
    "Datum und Uhrzeit der Erfahrung müssen in der Zukunft liegen. Wählen Sie einen späteren Termin, wenn Sie die Buchung korrigieren müssen.",
  confirmSlotRequired:
    "Wählen Sie ein Zeitfenster oder geben Sie eine individuelle Uhrzeit ein.",
  confirmSlotsLabel: "Zeitfenster",
  confirmSlotsLoading: "Zeitfenster werden geladen…",
  confirmSlotsError: "Zeitfenster für diesen Tag konnten nicht geladen werden.",
  confirmDayClosed: "Dieser Tag ist laut Plan geschlossen.",
  confirmNoSlots: "Für diesen Tag sind keine Zeitfenster konfiguriert.",
  confirmSlotSpotsRemaining: "{{count}} Platz/Plätze frei",
  confirmSlotInsufficient:
    "Nur {{remaining}} Platz/Plätze für {{partySize}} — Sie können trotzdem bestätigen",
  confirmSlotFull: "Ausgebucht — Sie können trotzdem bestätigen",
  confirmSlotUnlimited: "Verfügbar",
  confirmSlotRequested: "Angefragt",
  confirmCustomTimeLabel: "Individuelle Uhrzeit",
  confirmCustomTimeHint:
    "Nutzen Sie dies, wenn Sie eine Uhrzeit vereinbart haben, die nicht in der Liste steht. Dies nutzt nicht die Kapazität des Zeitfensters.",
  confirmVisitPrefillHint:
    "Aus der Kundenanfrage vorausgefüllt — ändern Sie es, wenn Sie im Chat einen anderen Termin vereinbart haben.",
  confirmBookingSuccess: "Buchung auf Flitrip bestätigt.",
  confirmBookingError: "Dieser Handshake konnte nicht bestätigt werden.",
  acceptBooking: "Annehmen",
  acceptBookingBusy: "Wird angenommen…",
  acceptBookingHint:
    "Bestätigen Sie die Buchung auf Flitrip, nachdem Sie mit dem Kunden Datum und Uhrzeit im Chat vereinbart haben.",
  rejectBooking: "Ablehnen",
  rejectBookingBusy: "Wird abgelehnt…",
  rejectBookingHint:
    "Lehnen Sie diese Anfrage ab. Der Kunde wird benachrichtigt und die Buchung wird nicht fortgesetzt.",
  rejectSessionTitle: "Diese Buchung ablehnen?",
  rejectSessionConfirm:
    "Der Kunde wird darüber informiert, dass seine Anfrage abgelehnt wurde.",
  rejectSessionAction: "Ablehnen",
  confirmOverCapacityTitle: "Zeitfenster-Kapazität überschreiten?",
  confirmOverCapacityMessage:
    "Dieses Zeitfenster erlaubt bis zu {{maxCapacity}} Plätze. {{bookedCount}} sind bereits bestätigt und nur {{availableSpots}} Platz/Plätze verbleiben, aber diese Buchung ist für {{partySize}}. Sie können trotzdem bestätigen, wenn Sie sie annehmen möchten.",
  confirmOverCapacityConfirm: "Trotzdem bestätigen",
  conversationExpired: "Diese Unterhaltung ist abgelaufen",
  conversationCancelledStatus: "Diese Unterhaltung ist storniert",
  backToDashboard: "Zurück zum Dashboard",
  sessionIdShort: "Sitzungs-ID",
  cancelSession: "Sitzung stornieren",
  updated: "Aktualisiert",
  closed: "Geschlossen",
  references: "Referenzen",
  bookingId: "Buchungs-ID",
  sellerId: "Verkäufer-ID",
  auditTrail: "Audit-Protokoll ({{count}} Nachrichten)",
  blockedCount: "Blockiert: {{count}}",
  noMessages: "Noch keine Nachrichten in dieser Unterhaltung.",
  list: {
    quickStatusLabel: "Nach Status filtern",
    quickStatusAll: "Alle",
    adminTitle: "Handshake-Dashboard",
    adminDescription:
      "Alle Kunden-Verkäufer-Unterhaltungen prüfen und überwachen",
    conversationsFound_one: "{{count}} Unterhaltung gefunden",
    conversationsFound_other: "{{count}} Unterhaltungen gefunden",
    loadingConversations: "Unterhaltungen werden geladen...",
    noConversationsFound: "Keine Unterhaltungen gefunden",
    tryAdjustingFilters: "Passen Sie Ihre Filter an",
    emptyHintAdmin: "Noch keine Handshake-Unterhaltungen",
    clearFilters: "Filter zurücksetzen",
    loadFailedTitle: "Unterhaltungen konnten nicht geladen werden",
    loadFailedHint: "Prüfen Sie Ihre Verbindung und versuchen Sie es erneut.",
    loadFailedRetry: "Erneut versuchen",
    loadFailedStale:
      "Liste konnte nicht aktualisiert werden. Zuletzt geladene Unterhaltungen werden angezeigt.",
  },
} as const;
